import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbDropdownConfig, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import * as CryptoJS from 'crypto-js';
import { Subject } from 'rxjs';
import { AuthService } from '../../auth/auth.service';
import { UserDto } from '../../auth/user.dto';
import { ConfigService } from '../../shared/services/config.service';
import { UserService } from '../../shared/services/user.service';
import { SignatureComponent } from '../../shared/signature/signature.component';
import { SignatureDto } from '../../shared/signature/signature.dto';
import { ToastService } from '../../shared/toast/toast.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  providers: [NgbDropdownConfig],
  standalone: false,
})
export class MenuComponent implements OnInit, OnDestroy {
  public user: UserDto | undefined = undefined;
  public pcAccountUrl: string;
  private readonly destroy$: Subject<void> = new Subject();

  constructor(
    private readonly authService: AuthService,
    private readonly modalService: NgbModal,
    private readonly userService: UserService,
    private readonly toastService: ToastService,
    private readonly configService: ConfigService,
    config: NgbDropdownConfig,
  ) {
    config.placement = 'right';
  }

  public async ngOnInit(): Promise<void> {
    this.user = await this.authService.getUser();
    this.pcAccountUrl = (await this.configService.getPcAccountURL()).url;
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public disconnect(): void {
    this.authService.logout();
  }

  public async editSignature(): Promise<void> {
    const { id, signatureData } = (await this.userService.getSignature()) || {};
    const checksum1: string = CryptoJS.MD5(signatureData).toString();
    const signatureDataURL: string = await this.openConfirmationModal(signatureData);
    const checksum2: string = CryptoJS.MD5(signatureDataURL).toString();

    if (signatureDataURL && checksum1 !== checksum2) {
      await this.userService.saveSignature(new SignatureDto(id, signatureDataURL));
      this.toastService.show('Votre signature a été modifiée avec succès.', 'success');
    }
  }

  private async openConfirmationModal(signatureDataURL: string): Promise<any> {
    const modal: NgbModalRef = this.modalService.open(SignatureComponent, {
      backdrop: 'static',
      centered: true,
      size: 'md',
    });
    const modalComponent: SignatureComponent = modal.componentInstance as SignatureComponent;
    modalComponent.signatureDataURL = signatureDataURL;
    modalComponent.title = 'Signature';
    return modalComponent.confirm();
  }
}
